var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinviaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Finvia_logo",
    "data-name": "Finvia logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.349,
    height: 24,
    viewBox: "0 0 169.349 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M33.6,20.542h3.84V12.671h7.679V9.215H37.437V4.8H52.8V1.344H33.6Z",
    transform: "translate(23.995 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M51.437,1.344H47.6v19.2h3.84Z",
    transform: "translate(33.994 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M68.558,14.591,56.655,1.344H53.2v19.2h3.84V7.3l11.9,13.247H72.4V1.344h-3.84Z",
    transform: "translate(37.995 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M77.741,17.087h-.384L70.907,1.344H66.76l7.871,19.2h5.76l7.871-19.2h-4.07Z",
    transform: "translate(47.68 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M85.5,1.344h-3.84v19.2H85.5Z",
    transform: "translate(58.32 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M99.879,1.344H94.12l-7.872,19.2h4.07l1.574-3.84h10.137l1.574,3.84h4.147Zm-6.566,11.9L96.769,4.8h.384l3.456,8.447Z",
    transform: "translate(61.598 0.96)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M13.447,12,9.375,7.927,13.23,4.072h0L17.3,0l24,24H33.154L17.3,8.146Z",
    transform: "translate(6.696)",
    fill: "#038b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M28.07,19.849,14.034,5.813,9.962,9.886,0,19.849H8.146l5.888-5.89,5.89,5.89Z",
    transform: "translate(0 4.151)",
    fill: "#038b9b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinviaLogo);
export default __webpack_public_path__ + "static/media/finvia-logo.27922ed9019701c69fd65e067c5285b7.svg";
export { ForwardRef as ReactComponent };